export function Section({
  title,
  action,
  children
}: {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="pt-6">
      <div className="flex items-center justify-between pb-[10px]">
        <span className="text-[13px] font-bold tracking-snug text-ink">{title}</span>
        {action}
      </div>
      {children}
    </div>
  );
}
